'use client';

import { type Table } from '@tanstack/react-table';
import { RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { OfferItem } from '@/lib/api/offers';

interface OffersTableActionsProps {
    table: Table<OfferItem>;
    onRefresh: () => void;
    isLoading: boolean;
    storeId: string;
}

/**
 * OffersTableActions component for table toolbar actions
 */
export const OffersTableActions = ({ table, onRefresh, isLoading, storeId }: OffersTableActionsProps) => {
    return (
        <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
                <RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                Refresh
            </Button>
        </div>
    );
};

